import React from 'react';
import { withApollo } from '@apollo/client/react/hoc';
import { Field } from 'formik';

import SchoolNameSearchQuery from 'buyside/graphql/queries/SchoolNameSearch';

import AutocompleteField from 'buyside/components/presentation/Form/Field/AutocompleteField/autocompleteField';

export class EducationAutocomplete extends React.Component {
  constructor() {
    super();
    this.state = { loading: false, suggestions: [] };
    this.selectIntercept = this.selectIntercept.bind(this);
    this.changeIntercept = this.changeIntercept.bind(this);
  }

  selectIntercept(value, selectedItem) {
    const { name, setFieldValue } = this.props;

    if (this.props.overrideDefault) {
      setFieldValue(name, selectedItem);
    } else {
      setFieldValue(name + '.schoolName', selectedItem);
    }
  }

  changeIntercept(query) {
    this.setState({ loading: true });
    this.props.client.query({ query: SchoolNameSearchQuery, variables: { query } }).then(res => {
      this.setState({
        loading: false,
        suggestions: res.data.schoolNameSearch
      });
    });
  }

  render() {
    const autosuggestOptions = {};
    const { overrideDefault, name, locked } = this.props;
    const fieldName = overrideDefault ? name : `${name}.schoolName`;
    return (
      <Field
        component={AutocompleteField}
        analyticsTag={this.props.analyticsTag}
        name={fieldName}
        label="Institution"
        locked={locked}
        changeIntercept={this.changeIntercept}
        selectIntercept={this.selectIntercept}
        suggestions={this.state.suggestions}
        handleSuggestionsClearRequested={() => this.setState({ suggestions: [] })}
        formatSuggestion={suggestion => suggestion}
        getSuggestionValue={suggestion => suggestion}
        isWide
        autosuggestOptions={autosuggestOptions}
        loading={this.state.loading}
        debounce
      />
    );
  }
}

export default withApollo(EducationAutocomplete);
